import React, {Dispatch, SetStateAction, useEffect} from 'react';
import {motion} from "framer-motion";
import s from "../CurrencyExchange.module.css";
import {Formik, useFormikContext} from "formik";
import MyInput from "../../../../../components/ui/MyInput/MyInput";
import MyBtn from "../../../../../components/ui/MyBtn/MyBtn";
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux";
import CustomDropdownForAccounts
    from "../../../../../components/ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import * as yup from "yup";
import {
    setCurrencyExchangeAmount,
    setCurrencyExchangeFrom,
    setCurrencyExchangeResult, setCurrencyExchangeTo
} from "../../../../../store/reducers/UserSlice";
import {sendCurrencyExchange} from "../../../../../store/reducers/ActionCreators";
import useDebounce from "../../../../../hooks/useDebounce";
import {useAccountsForSelect} from "../../../../../hooks/useAccountsForSelect";

type PropsType = {
    setCurrent: Dispatch<SetStateAction<number>>
    current: number
    setExchangeData: Dispatch<SetStateAction<any>>
}

const SetCurrencyByAccount = (props: any) => {

    const {values, setFieldValue} = useFormikContext();

    const dispatch = useAppDispatch()

    useEffect(() => {
        props.accountsForSelect.map(async (account: any) => {
            // @ts-ignore
            if (account.number === values?.accNumberFrom) {
                await dispatch(setCurrencyExchangeAmount(null))
                await dispatch(setCurrencyExchangeResult(null))
                await dispatch(setCurrencyExchangeFrom(account.currency))
                setFieldValue('forAmountCurrency', account.currency)
                setFieldValue('amount', '')
                setFieldValue('toAmount', '')
            }
        })
        // @ts-ignore
    }, [values.accNumberFrom])

    useEffect(() => {
        props.accountsForSelect.map(async (account: any) => {
            // @ts-ignore
            if (account.number === values?.accNumberTo) {
                await dispatch(setCurrencyExchangeAmount(null))
                await dispatch(setCurrencyExchangeResult(null))
                await dispatch(setCurrencyExchangeTo(account.currency))
                setFieldValue('getAmountCurrency', account.currency)
                setFieldValue('amount', '')
                setFieldValue('toAmount', '')
            }
        })
        // @ts-ignore
    }, [values.accNumberTo])

    useEffect(() => {


        // @ts-ignore
        if (!!values.amount && values?.amount?.length > 0) {
            // @ts-ignore
            dispatch(setCurrencyExchangeFrom(values.forAmountCurrency))
            // @ts-ignore
            dispatch(setCurrencyExchangeTo(values.getAmountCurrency))
            // @ts-ignore
            dispatch(setCurrencyExchangeAmount(values.amount))

        }

        // @ts-ignore
        if (!!values.toAmount && values?.toAmount?.length > 0) {
            // @ts-ignore
            dispatch(setCurrencyExchangeFrom(values.getAmountCurrency))
            // @ts-ignore
            dispatch(setCurrencyExchangeTo(values.forAmountCurrency))
            // @ts-ignore
            dispatch(setCurrencyExchangeAmount(values.toAmount))
        }
        // @ts-ignore
    }, [values.amount, values.toAmount])

    useEffect(() => {
        // @ts-ignore
        if (values.amount === '') {
            dispatch(setCurrencyExchangeResult(null))
            // @ts-ignore
            dispatch(setCurrencyExchangeAmount(null))
        }
        // @ts-ignore
    }, [values.amount])

    useEffect(() => {
        // @ts-ignore
        if (values.toAmount === '') {
            dispatch(setCurrencyExchangeResult(null))
            // @ts-ignore
            dispatch(setCurrencyExchangeAmount(null))
        }
        // @ts-ignore
    }, [values.toAmount])

    return null;
};

const validationSchema = yup.object({
    amount: yup.string()
        .matches(/^[0-9]+$/, "Must be only digits")
        .test({
            message: 'One of the fields is required',
            test: function (value) {
                const {toAmount} = this.parent;
                if (!toAmount) return value !== undefined && value !== null && value !== '';
                return true
            },
        }),
    toAmount: yup.string()
        .matches(/^[0-9]+$/, "Must be only digits")
        .test({
            message: 'One of the fields is required',
            test: function (value) {
                const {amount} = this.parent;
                if (!amount) return value !== undefined && value !== null && value !== '';
                return true
            },
        }),
})

const ExchangeStepOne = (props: PropsType) => {
    const accountsForSelect = useAccountsForSelect()
    const currencyExchange = useAppSelector(state => state.userReducer.currencyExchange)
    const currencyExchangeResult = useAppSelector(state => state.userReducer.currencyExchangeResult)
    const dispatch = useAppDispatch()

    const handleRequest = (debouncedValue: any) => {
        if (!currencyExchange.amount || currencyExchange.amount === 0 || currencyExchange.amount === '') return
        dispatch(sendCurrencyExchange(debouncedValue))
    }

    const debouncedValue = useDebounce(currencyExchange, 1500);

    useEffect(() => {
        handleRequest(debouncedValue)
    }, [debouncedValue])

    useEffect(() => {

        return () => {
            dispatch(setCurrencyExchangeAmount(null))
            dispatch(setCurrencyExchangeResult(null))
            dispatch(setCurrencyExchangeFrom(''))
            dispatch(setCurrencyExchangeTo(''))
        }

    }, [])

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >
            <div className={s.wrapper}>
                <Formik
                    initialValues={{
                        accNumberFrom: '',
                        accNumberTo: '',
                        amount: '',
                        forAmountCurrency: '',
                        toAmount: '',
                        getAmountCurrency: '',
                        type: "exchange"
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        const tempData = {
                            ...values,
                            result: currencyExchangeResult
                        }
                        props.setExchangeData([tempData])
                        props.setCurrent(1)
                    }}
                >
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit
                      }) => (

                        <form onSubmit={handleSubmit} className={s.form}>
                            <div className={s.flex}>
                                <div className={s.dropdown_block}>
                                    <div className={s.input_label}>
                                        from account
                                    </div>
                                    <CustomDropdownForAccounts
                                        id={'accNumberFrom'}
                                        name={'accNumberFrom'}
                                        items={accountsForSelect}
                                    />
                                </div>
                                <div className={s.dropdown_block}>
                                    <div className={s.input_label}>
                                        to account
                                    </div>
                                    <CustomDropdownForAccounts
                                        id={'accNumberTo'}
                                        name={'accNumberTo'}
                                        items={accountsForSelect}
                                    />
                                </div>
                            </div>
                            <div className={s.flex}>
                                <div className={s.amount_block}>
                                    <div className={s.amount_input}>
                                        <div className={s.input_label}>
                                            For
                                        </div>
                                        <MyInput
                                            disabled={!!values.toAmount}
                                            id={'amount'}
                                            name={'amount'}
                                            value={(currencyExchangeResult && !values.amount) ? currencyExchangeResult : values.amount}
                                            onChange={handleChange}
                                        />
                                      {errors.amount && touched.amount &&
                                          <div className={s.error_message}>{errors.amount}</div>}
                                    </div>
                                    <div className={s.currency_input_block}>
                                        <div className={s.input_label}>
                                            Currency
                                        </div>
                                        <MyInput
                                            id={'forAmountCurrency'}
                                            name={'forAmountCurrency'}
                                            value={values.forAmountCurrency}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <div className={s.amount_block}>
                                    <div className={s.amount_input}>
                                        <div className={s.input_label}>
                                            Get
                                        </div>
                                        <MyInput
                                            disabled={!!values.amount}
                                            id='toAmount'
                                            name='toAmount'
                                            value={(currencyExchangeResult && !values.toAmount) ? currencyExchangeResult : values.toAmount}
                                            onChange={handleChange}
                                        />
                                      {errors.toAmount && touched.toAmount &&
                                          <div className={s.error_message}>{errors.toAmount}</div>}
                                    </div>
                                    <div className={s.currency_input_block}>
                                        <div className={s.input_label}>
                                            Currency
                                        </div>
                                        <MyInput
                                            id={'getAmountCurrency'}
                                            name={'getAmountCurrency'}
                                            value={values.getAmountCurrency}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={s.button_wrapper}>
                                <div className={s.button_block}>
                                    <MyBtn title={'Continue'} type={'submit'}/>
                                </div>
                            </div>
                            <SetCurrencyByAccount
                                accountsForSelect={accountsForSelect}
                                selectedAccountCurrencyGet={currencyExchange.to}
                                selectedAccountCurrencyFor={currencyExchange.from}
                            />
                        </form>

                    )}
                </Formik>
            </div>
        </motion.div>
    );
};

export default ExchangeStepOne;
